import type { PopularAnalysis } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'
import type { PopularTypeContextItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

const mapPopularType = (item: PopularTypeContextItem): PopularAnalysis => ({
  name: item.service_type_name,
  href: item.page_link,
})

export default mapPopularType
